var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 2.66797C4.96514 2.66797 4.66667 2.96645 4.66667 3.33464V12.668C4.66667 13.0362 4.96514 13.3346 5.33333 13.3346C5.70152 13.3346 6 13.0362 6 12.668V3.33464C6 2.96645 5.70152 2.66797 5.33333 2.66797Z",
    fill: "#272B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6693 2.66797C10.3011 2.66797 10.0026 2.96645 10.0026 3.33464V12.668C10.0026 13.0362 10.3011 13.3346 10.6693 13.3346C11.0375 13.3346 11.3359 13.0362 11.3359 12.668V3.33464C11.3359 2.96645 11.0375 2.66797 10.6693 2.66797Z",
    fill: "#272B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseNew);
export default __webpack_public_path__ + "static/media/pause_new.1a3f137997ed75d25f94f4ce71b127b1.svg";
export { ForwardRef as ReactComponent };